import { Link, useParams } from "react-router-dom";
import { DocumentContent } from "@/src/components/ContentBlocks";
import { labs, weeks } from "@/src/lib/content";

function PrintButton() {
  return <button className="button primary" type="button" onClick={() => window.print()}>Print or save as PDF</button>;
}

function MaterialPage({ area }: { area: "week" | "lab" }) {
  const { slug, docId } = useParams<{ slug: string; docId: string }>();
  const parent = area === "week" ? weeks.find((entry) => entry.slug === slug) : labs.find((entry) => entry.slug === slug);
  const doc = parent?.docs.find((entry) => entry.id === docId);
  const parentPath = parent ? `/course/${area}/${parent.slug}` : "/course";
  if (!parent || !doc) return <main id="main-content" className="student-page-hero shell"><p className="eyebrow">Course material</p><h1>Material not found</h1><p>Return to the course map and open the material from its week or lab.</p><Link className="button primary" to="/course">Course map</Link></main>;
  const parentLabel = area === "week" ? `${parent.number === 0 ? "Pre-course" : `Week ${parent.number}`}: ${parent.title}` : `Lab ${parent.number}: ${parent.title}`;
  return (
    <main id="main-content" className="material-page">
      <section className="material-page-hero paper-section">
        <div className="shell">
          <p className="eyebrow">{parentLabel} · {doc.kind}</p>
          <h1>{doc.title}</h1>
          <p className="lede">{doc.summary}</p>
          <div className="material-toolbar"><Link className="button secondary" to={parentPath}>Back to {area}</Link><PrintButton /></div>
        </div>
      </section>
      <section className="section shell material-page-document"><DocumentContent html={doc.html} /></section>
    </main>
  );
}

export function WeekMaterialPage() { return <MaterialPage area="week" />; }
export function LabMaterialPage() { return <MaterialPage area="lab" />; }
